import React, { FunctionComponent } from "react";
import { UI } from "@wwimmo/ui";
import { GetNewsDetailsById_newsitems_newsfileimage as db_newsfileimage } from "src/api/generated/GetNewsDetailsById";
import styles from "../NewsEditForm.module.css";
import { useTranslation } from "react-i18next";

type NewsImageSectionProps = {
    selectedFiles: File[];
    dbNewsFileImage: db_newsfileimage | undefined;
    getRootProps: (...args: any[]) => any;
    getInputProps: (...args: any[]) => any;
    onRemoveImageFile: () => void;
};

export const NewsImageSection: FunctionComponent<NewsImageSectionProps> = ({
    selectedFiles,
    dbNewsFileImage,
    getRootProps,
    getInputProps,
    onRemoveImageFile
}) => {
    const { t } = useTranslation();
    const hasFile = selectedFiles.length > 0 || dbNewsFileImage;

    return (
        <div className={styles.FilesDropZoneContainer}>
            {!hasFile && (
                <div {...getRootProps({ className: styles.FilesDropZone })}>
                    <input {...getInputProps()} />
                    <div>{t("screens.realestate.news_edit.add_image")}</div>
                </div>
            )}
            {hasFile && (
                <div className={styles.CurrentlySelectedFileContainer}>
                    <div>{selectedFiles.length > 0 ? selectedFiles[0].name : dbNewsFileImage?.name}</div>
                    <UI.Icon
                        size={20}
                        onClick={onRemoveImageFile}
                        icon={UI.SVGIcon.Close}
                        className={styles.RemoveFileIcon}
                    />
                </div>
            )}
        </div>
    );
};
